import { useTranslation } from 'react-i18next'

import { AddCircleOutlineIcon, Button, FileIcon, Text } from '@mercai/clever'

import { CardInfo } from '../card-info'

import { CardDocumentsProps } from './card-documents.type'

import styles from './card-documents.module.css'
import { FileInfo } from '../file-info'

export const CardDocuments = ({
  isLoading,
  title,
  data,
  onAdd = () => null,
  actions,
  hasHeader = true,
  isEditable,
}: CardDocumentsProps) => {
  const { t } = useTranslation('componentsCardDocuments')

  return (
    <CardInfo
      title={title || t('title')}
      icon={<FileIcon />}
      hasHeader={hasHeader}
      actions={
        actions ||
        (isEditable && (
          <Button
            variant="ghost"
            size="small"
            onClick={onAdd}
            className={styles['add-button']}
          >
            {t('addFiles')}
            <AddCircleOutlineIcon />
          </Button>
        ))
      }
    >
      {data &&
        data?.map(
          ({ title, file, onUpdate, previewDocument, ...props }, index) => {
            if (props.data) {
              return (
                <div key={index}>
                  <Text variant="text-base" className={styles['section-title']}>
                    {title}
                  </Text>
                  {props.data?.map(
                    ({ title, file, onUpdate, previewDocument }, index) => {
                      return (
                        <FileInfo
                          key={index}
                          file={file || ''}
                          isLoading={isLoading}
                          title={title}
                          onUpdate={onUpdate}
                          showPreview={previewDocument}
                        />
                      )
                    },
                  )}
                </div>
              )
            }

            return (
              <FileInfo
                key={index}
                file={file || ''}
                isLoading={isLoading}
                title={title}
                onUpdate={onUpdate}
                showPreview={previewDocument}
              />
            )
          },
        )}
      {(!data || data.length === 0) && !isLoading && (
        <Text>{t('emptyLabel')}</Text>
      )}
    </CardInfo>
  )
}
